import Link from "next/link";

import { ArticleCard } from "@/components/articleCard/articleCard.component";
import { CarouselCentered } from "@/components/carouselCentered/carouselCentered.component";
import { Text } from "@/components/text/text.component";

import type { GetResourcesPageQueryResult } from "@/sanity.types";

export const ArticleGroup = ({ block }: ArticleGroupProps) => {
  const articles = block.category?.articles ?? [];

  if (!block.title) return null;

  const renderArticleGroup = () => {
    if (!articles.length) {
      return (
        <Text variant="body1" component="p">
          No articles have been published in this category yet.
        </Text>
      );
    }
    return (
      <CarouselCentered
        data-testid="article-group-carousel"
        mobileSlidesPerView={1.15}
        desktopSlidesPerView={4}
        mobileSpaceBetween={20}
        desktopSpaceBetween={24}
        centeredSlides={false}
        initialSlide={0}
        equalSlideHeights
        swiperItemsClassName="self-stretch"
        slideInnerClassName="h-full">
        {articles.map((article) =>
          article?._id ? (
            <ArticleCard key={article._id} article={article} />
          ) : null,
        )}
      </CarouselCentered>
    );
  };
  return (
    <section data-testid="article-group" className="w-full py-10 md:py-14">
      <div className="container mx-auto flex flex-col gap-8 px-4">
        <div className="flex justify-center md:justify-between">
          <Text
            variant="h5"
            component="h2"
            className="text-greyscale-headline"
            data-testid="article-group-title">
            {block.title}
          </Text>
          <Link href={block.category.slug} className="hidden underline md:flex">
            View all
          </Link>
        </div>
        {renderArticleGroup()}
        <Link
          href={block.category.slug}
          className="w-full text-center underline md:hidden">
          View all
        </Link>
      </div>
    </section>
  );
};

type PageBuilderBlock = NonNullable<
  NonNullable<GetResourcesPageQueryResult>["pageBuilder"]
>[number];

export type ArticleGroupBlock = Extract<
  PageBuilderBlock,
  { _type: "articleGroup" }
>;

export type ArticleGroupProps = {
  block: ArticleGroupBlock;
};
